import { AbsoluteModelPath, convertToLegacyPath } from "../../../../Common/ModelPath/ModelPath";
import { BindingPath } from "../../Engine/Core/CoreTypes";

export type OptionalComponentIdExtractor<TProp> = undefined | ((props: TProp) => Iterable<string | undefined>);

export type ComponentIdExtractor<TProp> = (props: TProp) => Iterable<string>;

export function normalizeComponentIdExtractor<TProps>(
    extractor: OptionalComponentIdExtractor<TProps>
): ComponentIdExtractor<TProps> {
    return function* extractComponentIdsNormalized(props: TProps): Iterable<string> {
        if (extractor == undefined) {
            // @ts-ignore Эту штуку обеспечивает перегрузка функции
            const bindingPath: AbsoluteModelPath | BindingPath | undefined = props.bindingPath;
            if (bindingPath != undefined) {
                yield convertToLegacyPath(bindingPath);
            }
        } else {
            for (const id of extractor(props)) {
                if (id != undefined) {
                    yield id;
                }
            }
        }
    };
}
